import React from 'react';
import homesfirst from '../images/homes-first-logo.png';
import runfor from '../images/run-for.png';
import mvm from '../images/mvm-logo.png';
import dixon from '../images/dixon-hall-logo.jpg';
import goodshepherd from '../images/good-shepherd.png';
import busby from '../images/busby-centre-logo.png';

const partners = [
    {
        name: 'Homes First',
        logo: homesfirst,
        description: 'A homeless shelter in Toronto. We collaborate with them to provide running shoes for individuals experiencing homelessness, ensuring they have access to quality footwear.',
    },
    {
        name: 'Run for Newmarket & Bradford',
        logo: runfor,
        description: 'These community running events allowed us to collect shoe donations while bringing people together for a cause. We are grateful for the contributions from participants.',
    },
    {
        name: 'Me Versus Me (MVM)',
        logo: mvm,
        description: 'MVM is a run club dedicated to empowering individuals through fitness. They support our mission by collecting shoes within their community and promoting our cause.',
    },
    {
        name: 'Dixon Hall Neighbourhood Services',
        logo: dixon,
        description: "Dixon Hall supports Toronto's downtown east with housing, employment, and community services. We help by providing shoes to individuals in their programs.",
    },
    {
        name: 'Good Shepherd',
        logo: goodshepherd,
        description: 'Good Shepherd offers shelter and support for those facing homelessness and poverty. We assist by donating shoes, helping individuals regain stability while receiving critical services.',
    },
    {
        name: 'The Busby Centre',
        logo: busby,
        description: 'The Busby Centre provides emergency shelter and wraparound support services in Barrie, Ontario. We partner with them to ensure individuals have proper footwear as they rebuild their lives.',
    },
];

const Partners = () => {
    return (
        <div id="partners" className="bg-gray-50 py-20">
            <section data-aos="fade-up">
                <div className="max-w-6xl mx-auto px-4 md:px-8">
                    {/* Section Header */}
                    <div className="text-center mb-14">
                        <h2 className="text-3xl font-bold text-black uppercase tracking-wide mb-3">
                            Our Partners
                        </h2>
                        <div className="flex justify-center mb-5">
                            <div className="w-16 border-b-4 border-black rounded-full"></div>
                        </div>
                        <p className="text-gray-500 text-lg max-w-2xl mx-auto">
                            Together with our community partners, we're putting shoes on the ground where it matters most.
                        </p>
                    </div>

                    {/* Partner Cards */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-aos="fade-up" data-aos-delay="200">
                        {partners.map((partner) => (
                            <div
                                key={partner.name}
                                className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 overflow-hidden group flex flex-col"
                            >
                                {/* Logo area — fixed height, centered */}
                                <div className="h-32 flex items-center justify-center px-8 pt-6 pb-4 bg-white">
                                    <img
                                        alt={partner.name}
                                        src={partner.logo}
                                        className="max-h-20 w-auto max-w-[160px] object-contain group-hover:scale-105 transition-transform duration-500 ease-in-out"
                                    />
                                </div>

                                {/* Divider */}
                                <div className="mx-6 border-t border-gray-100"></div>

                                {/* Text area */}
                                <div className="flex flex-col flex-1 px-6 py-5">
                                    <h3 className="font-semibold text-black text-lg mb-2">{partner.name}</h3>
                                    <p className="text-gray-500 text-sm leading-relaxed">{partner.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Partners;
